import { Component, OnInit } from '@angular/core';
import { SmsRegistrationService } from '../service/sms.service';
import { getImageSrc } from '../common/utils';
import { map, Observable } from 'rxjs';
import { RegistrationStage } from '../sms.constants';

interface SmsRegistrationBannerData {
  title: string;
  description: string;
  imagePath: string;
  badgeText: string;
  badgeColor: 'red' | 'yellow' | 'green';
}

@Component({
  selector: 'sms-registration-banner',
  templateUrl: './sms-registration-banner.component.html',
})
export class SmsRegistrationBannerComponent implements OnInit {
  registrationStage$: Observable<RegistrationStage>;
  bannerData$: Observable<SmsRegistrationBannerData>;

  notSubmittedImagePath = getImageSrc('collect-info-graphic.svg');
  notSubmittedTitle = 'Required information for US-based businesses';
  notSubmittedDescription =
    'To send SMS messages to customers, more details about your business are required. Fill out the form below to send SMS messages.';
  notSubmittedBadgeText = 'Status: Not submitted';

  processingImagePath = getImageSrc('reviewing-info-graphic.svg');
  processingTitle = 'Data submitted and under review';
  processingDescription =
    'Your business data is being reviewed. This process typically takes a few weeks, but in some cases may take longer.';
  processingBadgeText = 'Status: In progress';

  approvedImagePath = getImageSrc('registration-complete-graphic.svg');
  approvedTitle = 'Business registered for SMS';
  approvedDescription =
    'You can now access SMS features. Contact us if you need to make changes to your authorized business representative information.';
  approvedBadgeText = 'Status: Approved';

  protected readonly RegistrationStage = RegistrationStage;

  constructor(private smsRegistrationService: SmsRegistrationService) {}

  ngOnInit(): void {
    this.registrationStage$ = this.smsRegistrationService.registrationStage$;

    this.bannerData$ = this.registrationStage$.pipe(
      map((stage) => {
        switch (stage) {
          case RegistrationStage.NotSubmitted:
            return {
              title: this.notSubmittedTitle,
              description: this.notSubmittedDescription,
              imagePath: this.notSubmittedImagePath,
              badgeText: this.notSubmittedBadgeText,
              badgeColor: 'red',
            } as SmsRegistrationBannerData;
          case RegistrationStage.ReviewingInfo:
            return {
              title: this.processingTitle,
              description: this.processingDescription,
              imagePath: this.processingImagePath,
              badgeText: this.processingBadgeText,
              badgeColor: 'yellow',
            } as SmsRegistrationBannerData;
          case RegistrationStage.RegistrationComplete:
            return {
              title: this.approvedTitle,
              description: this.approvedDescription,
              imagePath: this.approvedImagePath,
              badgeText: this.approvedBadgeText,
              badgeColor: 'green',
            } as SmsRegistrationBannerData;
          default: // Should never happen
            return {
              title: '',
              description: '',
              imagePath: '',
              badgeText: '',
            } as SmsRegistrationBannerData;
        }
      }),
    );
  }
}
